import styles from './styles.module.css'
import TechInputColumn from '../tech-input-column/TechInputColumn'
import TechInputBar from '../tech-input-bar/TechInputBar'
import { ITechnicianPartial } from '../../../../../../../app/entities/Technician'
import { Dispatch, SetStateAction, useState } from 'react'
import { ILocation } from '../../../../../../../app/entities/Location'
import { Button } from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import DaySettingsManagementModal from '../../../../../locations/components/location-modal/components/day-settings-management-modal/DaySettingsManagementModal'

interface ITechnicianModalContentProps {
  technicianData: ITechnicianPartial
  setTechnicianData: Dispatch<SetStateAction<ITechnicianPartial>>
  isDefaultWorkDay: boolean
  setIsDefaultWorkDay: Dispatch<SetStateAction<boolean>>
  isDefaultLunch: boolean
  setIsDefaultLunch: Dispatch<SetStateAction<boolean>>
  technicianObjectId: string | undefined
  location: ILocation | null
  setLocation: Dispatch<SetStateAction<ILocation | null>>
}

function TechnicianModalContent({
  technicianData,
  setTechnicianData,
  isDefaultLunch,
  setIsDefaultLunch,
  isDefaultWorkDay,
  setIsDefaultWorkDay,
  technicianObjectId,
  location,
  setLocation,
}: ITechnicianModalContentProps) {
  const [isDaySettingsModalOpen, setIsDaySettingsModalOpen] = useState(false)

  // Check if we're creating a new technician (no objectId yet)
  const isCreatingNewTechnician = !technicianObjectId

  return (
    <div className={styles.mainContainer}>
      <TechInputColumn
        technicianData={technicianData}
        setTechnicianData={setTechnicianData}
        isDefaultWorkDay={isDefaultWorkDay}
        setIsDefaultWorkDay={setIsDefaultWorkDay}
        isDefaultLunch={isDefaultLunch}
        setIsDefaultLunch={setIsDefaultLunch}
        location={location}
      />
      <div className={styles.tableContainer}>
        <TechInputBar
          technicianData={technicianData}
          setTechnicianData={setTechnicianData}
          location={location}
          setLocation={setLocation}
        />

        {!location ? (
          // No location selected yet
          <div className={styles.locationPromptSection}>
            <div className={styles.sectionHeader}>
              <h3>Schedule Configuration</h3>
              <p>Please select a location to configure scheduling.</p>
            </div>
          </div>
        ) : isCreatingNewTechnician ? (
          // Creating new technician
          <div className={styles.convertedLocationSection}>
            <div className={styles.sectionHeader}>
              <h3>Schedule Management</h3>
              <p>This technician will be created with no working days. You can configure their schedule after creation.</p>
            </div>
          </div>
        ) : (
          // Editing existing technician - show schedule management
          <div className={styles.convertedLocationSection}>
            <div className={styles.sectionHeader}>
              <h3>Schedule Management</h3>
            </div>
            <Button
              variant="contained"
              startIcon={<CalendarMonthIcon />}
              onClick={() => setIsDaySettingsModalOpen(true)}
              className={styles.manageScheduleButton}
            >
              Manage Schedule
            </Button>
          </div>
        )}
      </div>

      {/* DaySettings Management Modal */}
      {!isCreatingNewTechnician && (
        <DaySettingsManagementModal
          isOpen={isDaySettingsModalOpen}
          onClose={() => setIsDaySettingsModalOpen(false)}
          locationObjectId={location?.objectId || ''}
          technicianObjectId={technicianObjectId}
        />
      )}
    </div>
  )
}

export default TechnicianModalContent
